export const isProducerGatewayPath = (pathname: string) =>
    pathname.startsWith("/producer/gateway");

export const producerGatewayLoginPath = "/producer/gateway/login";
export const producerGatewaySigninRedirectPath =
    "/producer/gateway/signin-redirect";
